<div class="background-image pt-3" id="explore_by_sector">
  <app-section-container>
    <app-section-heading>
      <span class="text__white">Explore by</span>
      <span class="text__primary"> Sector</span>
    </app-section-heading>
    <app-section-description>
      <span class="text__white">
        {{ description }}
      </span>
    </app-section-description>
    <div class="dropdown-section row justify-content-center m-auto">
      <app-sector-section-dropdown
        class="p-0"
        [sectors]="sectors"
        (onSectorSelect)="fetchArtifactCountBySector($event?.id)"
      ></app-sector-section-dropdown>
      <div class="d-flex justify-content-between align-items-center p-0">
        @for (artifact of artifactCount; track artifact) {
        <app-sector-section-button
          [artifactName]="artifact.name"
          [artifactCount]="artifact.count"
          (onArtifactSelect)="onArtifactSelect($event)"
        ></app-sector-section-button>
        }
      </div>
    </div>
  </app-section-container>
</div>
